import script from "./DocumentationPage.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentationPage.vue?vue&type=script&setup=true&lang=js"

import "./DocumentationPage.vue?vue&type=style&index=0&id=90fe04d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90fe04d8"]])

export default __exports__